import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Showcase, ShowcaseSearchParams} from '@accounting/_common/models/showcase.models';

export const CheckState = createAction(
    '[Showcase] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: Showcase[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Showcase] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: Showcase[] } }>()
);

export const LoadList = createAction(
    '[Showcase] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Showcase] Load List Success',
    props<{ payload: { items: Showcase[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Showcase] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Showcase] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Showcase] Set Filter',
    props<{ payload: ShowcaseSearchParams }>()
);

export const SetLoading = createAction(
    '[Showcase] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Showcase] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Showcase] Update Item Success',
    props<{ payload: Showcase }>()
);

export const DeleteItem = createAction(
    '[Showcase] Delete Item',
    props<{ payload: Showcase }>()
);

export const DeleteItemSuccess = createAction(
    '[Showcase] Delete Item Success',
    props<{ payload: Showcase }>()
);

export const DeleteItemFailure = createAction(
    '[Showcase] Delete Item Failure',
    props<{ payload: Showcase }>()
);

export const SetInitialState = createAction(
    '[Showcase] Set Initial State'
);
